import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { exportToCSV, exportDailyTasksToPDF } from '../../../utils/exportUtils';

const DailyTaskExportControls = ({ tasks, persons, currentDate }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleExportCSV = () => {
    const csvData = tasks?.map(task => {
      const person = persons?.find(p => p?.id === task?.personId);
      const timeStr = `${String(task?.time)?.padStart(2, '0')}:00`;
      return {
        Time: timeStr,
        Task: task?.title || '',
        Description: task?.description || '',
        Person: person?.name || '',
        Priority: task?.priority || '',
        Duration: `${task?.duration || 0} minutes`,
        Completed: task?.completed ? 'Yes' : 'No'
      };
    }) || [];
    
    exportToCSV(csvData, 'daily-tasks.csv');
    setShowMenu(false);
  };

  const handleExportPDF = () => {
    exportDailyTasksToPDF(tasks, persons, currentDate);
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        iconName="download"
        onClick={() => setShowMenu(!showMenu)}
      >
        Export
      </Button>

      {showMenu && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-border z-50">
            <div className="py-2">
              <button
                onClick={handleExportCSV}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="file-text" size={16} />
                Export as CSV
              </button>
              <button
                onClick={handleExportPDF}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="file" size={16} />
                Export as PDF
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DailyTaskExportControls;